import { IPatient, Languages, v2 } from '../../..';
import { getGender } from './helpers/getGender';

type PersonParts = Pick<
    IPatient,
    'firstName' | 'lastName' | 'middleName' | 'dateOfBirth' | 'gender' | 'languagesSpoken'
>;

export const personAdapter = (person: v2.Person): PersonParts => {
    const { firstName, lastName, middleName, dateOfBirth, gender, languagesFluent } = person;

    let languagesSpoken: Languages[] | undefined;

    if (languagesFluent) {
        languagesSpoken = languagesFluent
            .map((language) => Languages[language as keyof typeof Languages])
            .filter((language) => language);
    }

    return {
        firstName,
        lastName,
        middleName: middleName || undefined,
        dateOfBirth: dateOfBirth?.toISOString() || '',
        gender: getGender(gender?.name),
        languagesSpoken,
    };
};
